import React from 'react';
import PageList from '../../../components/PageListAPI'
import * as api from '../../../api/list'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';

export default function Equipment(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='equipment'
        columns={[{ id: 'name', name: 'Наименование' }, { id: 'typeE', name: 'Тип' }, { id: 'storageUnit', name: 'ед.изм.' }]}
        createItem={can(SLUGS.CATALOG.EQUIPMENT.MANAGE)}
        deleteItem={can(SLUGS.CATALOG.EQUIPMENT.MANAGE)}
        loadAPI={{
          request: api.getEquipment,
        }}
        title='Список материалов, оборудования'
        deleteAPI={api.deleteEquipment}
        filterProps={[
          {
            type: 'autocomplite',
            path: api.typequipment.getList.path,
            field: 'idType',
            name: 'Тип',
          },
        ]}
        {...props}
      />
    </div>
  )
};